import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H5, Image, LI, UL } from "../../../../AbstractElements";
import { Followers, Following, Posts } from "../../../../Constants/Constants";
import { SocialUserCardData } from "../../../../Data/Applications/Users/Users";
import { dynamicImage } from "../../../../Utils";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import SocialMediaIcons from "./SocialMediaIcons";

const AllCards = () => {
  return (
    <Fragment>
      {SocialUserCardData.map((item) => (
        <Col sm="6" xxl="3" xl="4" className="box-col-4" key={item.id}>
          <Card className="social-profile">
            <CardBody>
              <div className="social-img-wrap">
                <div className="social-img">
                  <Image className="img-fluid" src={dynamicImage(`${item.avatar}`)} alt="user" />
                </div>
                <div className="edit-icon">
                  <SvgIcon iconId="profile-check" />
                </div>
              </div>
              <div className="social-details">
                <H5 className="mb-1">
                  <Link to={`${process.env.PUBLIC_URL}/applications/social-app`}>{item.name}</Link>
                </H5>
                <span className="f-light">{item.email}</span>
                <SocialMediaIcons />
                <UL className="social-follow">
                  <LI>
                    <H5 className="mb-0">{item.totalPost}</H5>
                    <span className="f-light">{Posts}</span>
                  </LI>
                  <LI>
                    <H5 className="mb-0">{item.follower}</H5>
                    <span className="f-light">{Followers}</span>
                  </LI>
                  <LI>
                    <H5 className="mb-0">{item.following}</H5>
                    <span className="f-light">{Following}</span>
                  </LI>
                </UL>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};
export default AllCards;
